import {TextAlignment, TextTag} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import LottieButtonStartCTA from '../components/LottieButtonStartCTA';
import {QuestionWrapper} from './index';
import BodyText from '../components/BodyText';
import useQuestionStore from '../store/navigation';
import TypographyHeading from '../components/Typography/TypographyHeading';
import {QUESTIONIDS} from '../types/question';
import Div from '../components/Div.styled';
import {sendAnalyticPayload} from '../utils/analytic';
import {QuestionData} from '../constants/questions';

export function QuestionLanding(): JSX.Element {
  const {setCurrentQuestion, currentQuestion} = useQuestionStore();

  function onClickStart() {
    setCurrentQuestion(QUESTIONIDS.questionOneName);
    sendAnalyticPayload({
      process: {
        StepName: 'Start',
        StepNumber:
          QuestionData[currentQuestion]?.progressValue.toString() || '',
      },
    });
  }
  return (
    <QuestionWrapper>
      <Div
        customStyles={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0 32px',
        }}
      >
        <TypographyHeading textAlign={TextAlignment.center} size="large">
          Hey There!
        </TypographyHeading>
        <TypographyHeading
          textAlign={TextAlignment.center}
          bold={true}
          tag={TextTag.h3}
          size="large"
        >
          Let&apos;s find your eVW Fit
        </TypographyHeading>
        <Div
          customStyles={{
            marginTop: 40,
            maxWidth: 400,
          }}
        >
          <BodyText color="white">
            This will only take a few minutes. Let&apos;s find a Volkswagen EV
            that suits you best.
          </BodyText>
        </Div>
      </Div>
      <div
        style={{
          textAlign: 'center',
          width: '100%',
          transition: 'all 750ms ease-in-out',
        }}
      >
        <LottieButtonStartCTA onClick={onClickStart} />
      </div>
    </QuestionWrapper>
  );
}
